import { InputSummary, InputSummaryItem } from '../../../input-summary';
import InputSummaryUtils from '../../../../helper/input-summary/input-summary-util';
import { UnitValue } from '../../../data-structures/unit-value.model';
import {v4 as uuid} from 'uuid';
import { AnessaListItem } from '../../../anessa-list-item.interface';


export interface PartnershipInterface {
  name: string;
  uuid: string;
  investmentContribution: UnitValue;
  netIncomeShare: UnitValue;
}

export class Partnership implements AnessaListItem {
  name: string;
  uuid: string;
  investmentContribution: UnitValue;
  netIncomeShare: UnitValue;

  constructor(param: PartnershipInterface = {
    name: '',
    uuid: null,
    investmentContribution: new UnitValue(),
    netIncomeShare: new UnitValue()
  }) {
    this.name = param.name;
    this.uuid = param.uuid ? param.uuid : uuid();

    this.investmentContribution = new UnitValue(param.investmentContribution);
    this.netIncomeShare = new UnitValue(param.netIncomeShare);
  }

  static deepCopy(p: Partnership) {
    let copy;
    if (p) {
      copy = new Partnership(p);
      return copy;
    }
    throw new Error('Partnership copy failed');
  }

  getInputSummary(path: string[]) {
    const inputSummary = new InputSummary();
    inputSummary.inputs = this.getSummaryInputs(path);
    return inputSummary;
  }

  getSummaryInputs(path: string[]) {
    let inputs: InputSummaryItem[] = [];
    inputs = InputSummaryUtils.performPush(inputs, PartnershipPropName.InvestmentContribution, this.investmentContribution, [...path, 'investmentContribution']);
    inputs = InputSummaryUtils.performPush(inputs, PartnershipPropName.NetIncomeShare, this.netIncomeShare, [...path, 'netIncomeShare']);
    return inputs;
  }
}

export enum PartnershipPropName {
  Name = 'INPUT_SUMMARY.FINANCIAL.INVESTMENT.PARTNERSHIP.NAME',
  InvestmentContribution = 'INPUT_SUMMARY.FINANCIAL.INVESTMENT.PARTNERSHIP.INVESTMENT_CONTRIBUTION',
  NetIncomeShare = 'INPUT_SUMMARY.FINANCIAL.INVESTMENT.PARTNERSHIP.NET_INCOME_SHARE'
}
